import { Link } from "react-router-dom";
import { ArrowRight, Briefcase } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { SectionHeading } from "@/components/SectionHeading";
import { fadeUp } from "@/lib/motion";
import { EXPERTS } from "@/data/content";

const ExpertsSection = () => {
  return (
    <section className="relative py-24 sm:py-32 bg-white" id="experts" data-testid="experts-section">
      <div className="max-w-[1320px] mx-auto px-5 sm:px-8">
        <SectionHeading
          overline="Meet Our Experts"
          title="Former Agency Professionals on Your Side"
          description="Certification specialists who have worked inside the system — now working for you."
          className="mb-14"
        />

        <div className="grid sm:grid-cols-2 gap-8 max-w-4xl">
          {EXPERTS.map((e, i) => (
            <Reveal key={e.slug} variants={fadeUp} custom={i}>
              <div
                data-testid={`expert-card-${e.slug}`}
                className="group h-full rounded-3xl border border-slate-200 bg-white overflow-hidden hover:shadow-2xl hover:shadow-slate-900/10 transition-shadow duration-300"
              >
                <div className="relative h-72 overflow-hidden">
                  <img src={e.image} alt={`${e.name}, ${e.role}`} className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500" loading="lazy" />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#0F172A]/70 via-transparent to-transparent" />
                  <span className="absolute top-4 left-4 inline-flex items-center gap-1.5 rounded-full bg-white/90 backdrop-blur px-3 py-1.5 text-xs font-semibold text-[#1E40AF]">
                    <Briefcase className="w-3.5 h-3.5" /> {e.experience} Experience
                  </span>
                </div>
                <div className="p-7">
                  <h3 className="font-display font-bold text-xl text-[#0F172A]">{e.name}</h3>
                  <p className="mt-1 text-[#1E40AF] font-semibold text-sm">{e.shortRole}</p>
                  <p className="text-sm text-slate-500">{e.former}</p>
                  <p className="mt-4 text-sm text-slate-600 leading-relaxed line-clamp-3">{e.overview[0]}</p>
                  <Link
                    to={`/team#${e.slug}`}
                    data-testid={`expert-profile-${e.slug}`}
                    className="mt-5 inline-flex items-center gap-2 text-[#1E40AF] font-semibold text-sm hover:gap-3 transition-all"
                  >
                    Read Profile <ArrowRight className="w-4 h-4" />
                  </Link>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ExpertsSection;
